
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useFasting } from '@/contexts/FastingContext';
import { Flame, Shield, Sparkles } from 'lucide-react';

export const FastingBadges: React.FC = () => {
  const { timeElapsed } = useFasting();
  
  // Hours elapsed
  const hoursElapsed = timeElapsed / 3600;
  
  // Badge criteria based on fasting duration
  const showKetosis = hoursElapsed >= 18;
  const showAutophagy = hoursElapsed >= 24;
  const showImmunity = hoursElapsed >= 72;
  
  if (!showKetosis && !showAutophagy && !showImmunity) {
    return null;
  }
  
  return (
    <div className="flex flex-wrap gap-2 mb-4 justify-center">
      {showKetosis && (
        <Badge className="bg-fasttrack-blue text-white px-3 py-1 flex items-center gap-1">
          <Flame className="h-4 w-4 animate-pulse" /> Ketosis Active
        </Badge>
      )}
      
      {showAutophagy && (
        <Badge className="bg-fasttrack-purple text-white px-3 py-1 flex items-center gap-1">
          <Sparkles className="h-4 w-4" /> Autophagy Active
        </Badge>
      )}
      
      {showImmunity && (
        <Badge className="bg-green-500 text-white px-3 py-1 flex items-center gap-1">
          <Shield className="h-4 w-4" /> Immune Regeneration
        </Badge>
      )}
    </div>
  );
};
